import React, { useEffect, useRef } from 'react';
import 'swiper/css/bundle';
import { register } from 'swiper/element/bundle';
import './index.scss';


interface CarouselWidgetProps {
    // if true, the widget will stretch to its closest positioned ancestor (if any) or window
    stretch: boolean;
    slidesFactory: () => JSX.Element[]
}

register();

const CarouselWidget = (props: CarouselWidgetProps) => {
    const carouselParentElRef = useRef(null);
    const swiperElRef = useRef(null);
    const swiperSlideOffsetPlaceholderElRef = useRef(null);

    const doResize = function () {
        const carouselParentEl: any = carouselParentElRef.current;
        const swiperSlideOffsetPlaceholderEl: any = swiperSlideOffsetPlaceholderElRef.current;
        if (!(carouselParentEl instanceof HTMLElement)
            || !(swiperSlideOffsetPlaceholderEl instanceof HTMLElement)) {
            return;
        }
        const leftOffset = Math.max((carouselParentEl.getBoundingClientRect()?.left ?? 0), 0);
        swiperSlideOffsetPlaceholderEl.style.width = `${leftOffset}px`;
    }

    useEffect(() => {
        const swiperContainer: any = swiperElRef.current;
        const carouselParentEl: any = carouselParentElRef.current;
        if (!swiperContainer || !(carouselParentEl instanceof HTMLElement)) {
            return;
        }
        const params = {
            a11y: true,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            slidesOffsetAfter: 2,
            keyboard: {
                enabled: true,
            },
        };
        Object.assign(swiperContainer, params);
        props.stretch && doResize();

        swiperContainer.initialize();
        // parent height must be set after swiper is initialized.
        props.stretch && (carouselParentEl.style.height = `${swiperContainer.swiper?.height ?? 0}px`);
        props.stretch && swiperContainer.swiper?.on("beforeResize", doResize);
    }, []);

    return (
        <div className='hcr-carousel' ref={carouselParentElRef}>
            <div className={props.stretch ? `hcr-carousel-wrapper` : ''}>
            <swiper-container ref={swiperElRef} init={false}>
                <swiper-slide key={'placeholder'} class='swiper-slide-placeholder' ref={swiperSlideOffsetPlaceholderElRef} />
                {props.slidesFactory()}
            </swiper-container>
            </div>
        </div>
    );
};

export default CarouselWidget;
